import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CAMPAIGN } from "@/config/campaign";
import { getPhase } from "@/lib/phase";
import { trackEvent } from "@/lib/api";

export const FinalCta = ({ onScrollToForm }) => {
  const phase = getPhase();
  const active = phase === "active";
  return (
    <section className="bg-paper py-16 md:py-24" data-testid="final-cta-section">
      <div className="mx-auto max-w-[760px] px-5 text-center">
        <Reveal>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink md:text-6xl">
            {phase === "closed" ? "Der Wettbewerb ist beendet." : "26 echte Gewinner. Einer davon könntest du sein."}
          </h2>
        </Reveal>
        {phase !== "closed" && (
          <Reveal delay={0.12} className="mt-8">
            <button
              data-testid="final-cta-button"
              disabled={!active}
              onClick={() => {
                trackEvent("cta_click", "final");
                onScrollToForm();
              }}
              className="group inline-flex h-14 items-center justify-center gap-2 rounded-[14px] bg-gold px-8 font-display text-lg font-extrabold tracking-tight text-ink transition-[transform,background-color,opacity] duration-200 hover:bg-gold-dark active:scale-95 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {active ? "Jetzt kostenlos teilnehmen" : `Start am ${CAMPAIGN.launchLabel.replace(" 2026", "")}`}
              {active && <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" strokeWidth={2} />}
            </button>
            <p className="mt-3 text-sm text-mutedlight">Dauert weniger als 30 Sekunden. Kostenlos, keine Kaufpflicht.</p>
          </Reveal>
        )}
      </div>
    </section>
  );
};
